import type { MapData, MapNode } from '../types';

export function recalculateBalances(map: MapData): MapData {
  const result = structuredClone(map);
  const nodeMap = new Map<string, MapNode>();
  for (const node of result.nodes) {
    nodeMap.set(node.id, node);
  }

  // Pass 1: Keep PORT balances (set by backend), keep LIABILITY balances, reset others
  for (const node of result.nodes) {
    if (node.type === 'PORT') {
      // Preserve the backend-set randomized balance
    } else if (node.type === 'LIABILITY_ACCOUNT') {
      // Keep existing liability balance
    } else {
      node.balance = 0;
    }
  }

  // Pass 2: Compute from incoming actions (PORT -> direct children)
  for (const rule of result.rules) {
    for (const step of rule.steps) {
      for (const action of step.actions) {
        const sourceNode = nodeMap.get(action.sourceId);
        const destNode = nodeMap.get(action.destinationId);
        if (!sourceNode || !destNode) continue;
        if (destNode.type === 'LIABILITY_ACCOUNT') continue;

        const sourceBalance = sourceNode.balance || 0;
        let incoming = 0;

        if (action.type === 'PERCENTAGE') {
          incoming = Math.round((action.amountInPercentage / 100) * sourceBalance);
        } else if (action.type === 'FIXED' || action.type === 'TOP_UP') {
          incoming = action.amountInCents || 0;
        } else if (action.type === 'AVALANCHE' || action.type === 'SNOWBALL') {
          if (action.amountInPercentage) {
            incoming = Math.round((action.amountInPercentage / 100) * sourceBalance);
          } else if (action.amountInCents) {
            incoming = action.amountInCents;
          }
        }

        destNode.balance = (destNode.balance || 0) + incoming;
      }
    }
  }

  // Pass 3: Handle chains (non-PORT sources with balances)
  for (const rule of result.rules) {
    const sourceNode = nodeMap.get(rule.sourceId);
    if (!sourceNode || sourceNode.type === 'PORT') continue;
    const sourceBalance = sourceNode.balance || 0;
    if (sourceBalance === 0) continue;

    for (const step of rule.steps) {
      for (const action of step.actions) {
        const destNode = nodeMap.get(action.destinationId);
        if (!destNode || destNode.type === 'LIABILITY_ACCOUNT') continue;

        let incoming = 0;
        if (action.type === 'PERCENTAGE') {
          incoming = Math.round((action.amountInPercentage / 100) * sourceBalance);
        } else if (action.type === 'FIXED' || action.type === 'TOP_UP') {
          incoming = action.amountInCents || 0;
        } else if (action.type === 'AVALANCHE' || action.type === 'SNOWBALL') {
          if (action.amountInPercentage) {
            incoming = Math.round((action.amountInPercentage / 100) * sourceBalance);
          } else if (action.amountInCents) {
            incoming = action.amountInCents;
          }
        }

        destNode.balance = (destNode.balance || 0) + incoming;
      }
    }
  }

  // Pass 4: Fallback for nodes with 0 balance
  for (const node of result.nodes) {
    if (node.type !== 'PORT' && node.type !== 'LIABILITY_ACCOUNT' && node.balance === 0) {
      node.balance = 10000; // $100 fallback
    }
  }

  return result;
}
